import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import { useNavigate, useLocation } from "react-router-dom";

import CustomModal from "../../components/CustomModal";
import Banner from "../../components/Banner";

import * as Material from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import api from "../../helpers/api.js";

import Config, { token } from "../../config.js";

import "./styles.css";

import { ReactComponent as BoletoIcon } from "../../assets/custom-icons/barcode.svg";
import { ReactComponent as BuildProductDraw } from "../../assets/draws/product-creation.svg";
import AddIcon from "@mui/icons-material/Add";

import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PixIcon from "@mui/icons-material/Pix";
import PaymentIcon from "@mui/icons-material/Payment";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReplayIcon from "@mui/icons-material/Replay";

import { BarChart, barElementClasses } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import { ResponsiveChartContainer } from "@mui/x-charts/ResponsiveChartContainer";
import { useDrawingArea } from "@mui/x-charts/hooks";

import dayjs, { Dayjs } from "dayjs";

import networkGif from "../../assets/animations/network.gif";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";

import "react-image-crop/dist/ReactCrop.css";

import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { styled } from "@mui/material/styles";

import Screen from "../../components/Screen";

import MainButton from "../../components/SmallComponents/MainButton";

import { useChallenge } from "../../contexts/ChallengeContext";

export default function ProductsPage() {
  document.title = "Produtos | Ginastee";

  const { pathname } = useLocation();

  const [productDetailsModal, setProductDetailsModal] = useState({
    open: false,
    mode: "creation", //creation, update
  });

  const [accountEnabled, setAccountEnabled] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }, [pathname]);

  function onAccountEnabled() {
    console.log("Account enabled");
    setAccountEnabled(true);
  }
  function handleOpenAddNewProduct() {
    setProductDetailsModal({
      open: true,
      mode: "creation",
    });
  }
  function handleConfigureProduct(productInfo) {
    setProductDetailsModal({
      open: true,
      mode: "update",
      details: productInfo,
    });
  }

  function handleCreated(productId) {
    handleCloseProductDetails();
    window.loadProducts((products) => {
      const product = products.filter((p) => p.id === productId)[0];
      window.openPaymentsLinkModal(product.prices);
    });
  }

  function handleCloseProductDetails() {
    setProductDetailsModal({
      open: false,
      details: null,
      mode: "creation",
    });
  }

  const MEMO_ProductsList = useMemo(
    () => (
      <ProductsList
        handleConfigureProduct={handleConfigureProduct}
        handleCreateProduct={handleOpenAddNewProduct}
      />
    ),
    [pathname, accountEnabled]
  );

  return (
    <>
      <Screen title="Catálogo de produtos">
        <main className="products-screen pb-8">
          <h4 className="mt-1" style={{ maxWidth: "580px" }}>
            Crie seus próprios produtos, compartilhe com sua audiência e aumente
            seu faturamento com seus links de pagamento
          </h4>

          <AccountStatus handleAccountEnabled={onAccountEnabled} />

          <div className="add-new-product-container mt-5">
            <h3>Produtos criados</h3>

            <MainButton
              shadow={false}
              variant="contained"
              color="white"
              disabled={!accountEnabled}
              onClick={handleOpenAddNewProduct}
              endIcon={<AddIcon />}
              label={"Criar novo produto"}
            />
          </div>

          {accountEnabled && MEMO_ProductsList}
        </main>
      </Screen>
      <ProductConfig
        open={productDetailsModal?.open}
        onClose={handleCloseProductDetails}
        onCreated={handleCreated}
        details={productDetailsModal?.details}
        mode={productDetailsModal.mode}
      />
      <ProductLinksModal />
    </>
  );
}

function ProductsList({ handleConfigureProduct, handleCreateProduct }) {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (loading) handleLoadProducts();
  }, [loading]);

  async function handleLoadProducts(callback = () => {}) {
    try {
      const { data } = await api.get("bank/products");

      const activeProducts = data.filter((p) => p.active);

      setProducts([...activeProducts]);

      callback(activeProducts);
    } catch (e) {
      console.log(e);
      window.setSnackbar(
        "Houve um erro ao listar os produtos, recarregue a página"
      );
    }

    setLoading(false);
  }

  window.loadProducts = handleLoadProducts;

  function handleGetPaymentLinks(product) {
    window.openPaymentsLinkModal(product.prices);
  }
  function handleOpenUsers(state, productId) {
    window.navigate("/", {
      state: {
        filterUsers: {
          subscription_status: state,
          subscription_products: [productId],
        },
      },
    });
  }

  const Product = ({ data = {} }) => {
    const { insights } = data;

    const Prices = () => (
      <div className="prices-list">
        {loading ? (
          <Material.Skeleton
            className="mr-2"
            variant="rectangular"
            width={100}
            height={22}
          />
        ) : (
          <>
            {data.prices?.slice(0, 2).map((price, i) => (
              <Material.Chip
                size="small"
                style={{ marginLeft: 3 }}
                label={"R$" + getDisplayPrice(price.amount)}
              />
            ))}
            {data.prices?.length > 2 && <span> ...</span>}
          </>
        )}
      </div>
    );

    const HistoryChart = () => {
      const formatCurrencyBRL = (value) => {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
      };

      let alreadyCustomers = insights?.last_six_months?.map(
        (month) => (month.customers_total - month.new_customers) / 100
      );
      let newCustomers = insights?.last_six_months?.map(
        (month) => month.new_customers / 100
      );
      let hasHistory = !!insights?.last_six_months;

      if (!hasHistory) {
        newCustomers = [5, 4, 8, 7, 2, 3];
        alreadyCustomers = [8, 7, 5, 8, 12, 6];
      }

      const dataset = [];

      alreadyCustomers.forEach((c, i) => {
        dataset.push({
          newCustomers: newCustomers[i],
          alreadyCustomers: c,
          month: insights?.last_six_months[i].month,
        });
      });

      return (
        <div className="product-history">
          {!hasHistory && (
            <div className="no-history-message">
              <small>
                Ainda não existem dados suficientes do histórico deste produto
              </small>
            </div>
          )}
          <BarChart
            width={240}
            height={100}
            borderRadius={6}
            grid={{
              horizontal: true,
              vertical: true,
              classes: {
                ".MuiChartsGrid-line": {
                  color: "#0000ff",
                },
              },
            }}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "month",
                tickNumber: 3,
              },
            ]}
            yAxis={[
              {
                tickNumber: 3,
              },
            ]}
            slotProps={{ legend: { hidden: true } }}
            maintainAspectRatio={true}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            dataset={dataset}
            series={[
              {
                data: alreadyCustomers,
                label: "Receita de clientes antigos",
                stack: "#",
                valueFormatter: formatCurrencyBRL,
                color: "#6b2dee",
                dataKey: "alreadyCustomers",
              },
              {
                data: newCustomers,
                label: "Receita de clientes novos",
                stack: "#",
                valueFormatter: formatCurrencyBRL,
                color: "#cfb8ff",
                dataKey: "newCustomers",
              },
            ]}
          />
        </div>
      );
    };
    const InvoicingPercent = () => {
      const percent = insights?.invoice_percent || 0;

      const invoicingData = [
        { label: data.name, value: percent, color: "#6b2dee" },
        { label: "Outros produtos", value: 100 - percent, color: "#cfb8ff" },
      ];

      return (
        <div className="invoice-percent">
          <PieChart
            series={[
              {
                paddingAngle: percent === 0 ? 0 : 4,
                innerRadius: 30,
                outerRadius: 50,
                cornerRadius: 4,
                data: invoicingData,
              },
            ]}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            width={100}
            height={100}
            slotProps={{ legend: "dddd" }}
            legend={{ hidden: true }}
          ></PieChart>
          <span className="invoice-percent-label">
            {percent}% do faturamento
          </span>
        </div>
      );
    };

    const RedirectButton = ({
      disabled = false,
      tooltip,
      text,
      handleRedirect,
    }) => {
      return (
        <Material.Tooltip arrow title={disabled ? null : tooltip}>
          <button
            disabled={disabled}
            className="filter-users-btn"
            onClick={handleRedirect}
          >
            <h5>{text}</h5>
            <Material.IconButton size="small">
              <KeyboardArrowRightIcon color="primary" />
            </Material.IconButton>
          </button>
        </Material.Tooltip>
      );
    };

    return (
      <div className="product-row mb-3 ">
        <div className="pl-2  header-info">
          {!loading && (
            <span className="product-type">
              {data.type === "recurring" ? "recorrência" : "cob. única"}
            </span>
          )}

          {loading ? (
            <Material.Skeleton
              className="title mr-4"
              variant="rectangular"
              width={270}
              height={12}
            />
          ) : (
            <h4 className="px-1 title">{data.name}</h4>
          )}

          <Prices />

          {loading ? (
            <>
              <Material.Skeleton
                variant="rounded"
                className="mr-2"
                width={120}
                height={34}
              />
              <Material.Skeleton
                variant="rounded"
                className="mr-2"
                width={80}
                height={34}
              />
            </>
          ) : (
            <>
              <MainButton
                disabled={loading}
                shadow={false}
                variant="contained"
                color="white"
                onClick={() => handleGetPaymentLinks(data)}
                endIcon={<InsertLinkIcon />}
                label={"Links de pagamento"}
              />
              <MainButton
                disabled={loading}
                shadow={false}
                variant="contained"
                color="white"
                onClick={() => handleConfigureProduct(data)}
                endIcon={<SettingsIcon />}
                label={"Configurar"}
              />
            </>
          )}
        </div>
        <Material.Divider />
        <div className="px-2 py-1 product-info">
          {loading ? (
            <Material.Skeleton variant="rounded" width={80} height={80} />
          ) : (
            <>
              {data.banner_url && (
                <img src={data.banner_url} className="product-banner" />
              )}
            </>
          )}

          <div className="product-customers">
            {loading ? (
              <Material.Skeleton variant="rounded" width={130} height={30} />
            ) : (
              <RedirectButton
                tooltip="Ver clientes ativos"
                text={"Clientes ativos: " + (insights?.active_customers || 0)}
                handleRedirect={() =>
                  handleOpenUsers("at_least_one_active", data.id)
                }
              />
            )}

            <Material.Divider orientation="vertical" flexItem />

            {loading ? (
              <Material.Skeleton variant="rounded" width={130} height={30} />
            ) : (
              <RedirectButton
                tooltip="Ver clientes inativos"
                text={
                  "Clientes inativos: " + (insights?.inactive_customers || 0)
                }
                handleRedirect={() => handleOpenUsers("none_active", data.id)}
              />
            )}
          </div>

          <Material.Divider orientation="vertical" flexItem className="mr-2" />

          <div className="charts-area">
            {loading ? (
              <>
                <Material.Skeleton variant="rounded" width={130} height={80} />
                <Material.Skeleton variant="rounded" width={130} height={80} />
              </>
            ) : (
              <>
                <HistoryChart />
                <InvoicingPercent />
              </>
            )}
          </div>
        </div>
      </div>
    );
  };
  const NoProducts = ({}) => {
    return (
      <div className="no-products-box px-4 py-1">
        <BuildProductDraw className="no-products-draw" />
        <div>
          <h3>Crie seu primeiro produto</h3>
          <h5 className="pb-2">
            Adicione suas consultas / acompanhamentos ao sistema para ter 100%
            de controle sobre os pagamentos dos seus clientes
          </h5>
          <MainButton
            shadow={false}
            variant="contained"
            color="primary"
            onClick={handleCreateProduct}
            endIcon={<AddIcon />}
            label={"Criar novo produto"}
          />
        </div>
      </div>
    );
  };

  const productsDisplay = loading ? [{}, {}, {}, {}] : products;

  return (
    <div className="products-list mt-3">
      {productsDisplay.map((item, index) => (
        <Product data={item} key={index} />
      ))}
      {!loading && !products.length && <NoProducts />}
    </div>
  );
}

function AccountStatus({
  compactDisplay = false,
  handleAccountEnabled = () => {},
  style = {},
}) {
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState("LOADING");

  const REF_statusInfo = useRef();

  useEffect(() => {
    if (loading) handleLoadStatus();
  }, []);

  async function handleLoadStatus() {
    try {
      const { data } = await api.get("/bank/getAccountInfo");

      REF_statusInfo.current = { ...data };

      if (data?.error === "NO_ACCOUNT_FOUND") {
        setStatus("CREATE_ACCOUNT");
      } else if (data?.stripe_status === "incomplete") {
        setStatus("INCOMPLETE_ONBOARDING");
      } else if (data?.stripe_status === "complete") {
        handleAccountEnabled();
        setStatus("COMPLETE_ONBOARDING");
      } else {
        setStatus("UNKNOWN");
      }
    } catch (e) {
      setStatus("UNKNOWN");
      console.log(e);
    }

    setLoading(false);
  }

  const statusTitle = {
    CREATE_ACCOUNT: "Não criada",
    INCOMPLETE_ONBOARDING: "Cadastro incompleto",
    COMPLETE_ONBOARDING: "Conta ativa",
    UNKNOWN: "Em análise",
  }[status];

  const StatusComponent = {
    CREATE_ACCOUNT: () => {
      const [loadingCreation, setLoadingCreation] = useState(false);

      async function handleGoToAccountCreation() {
        setLoadingCreation(true);
        try {
          const { data } = await api.post("/bank/createAccount");

          if (data.link) {
            handleLoadStatus();

            window.open(data.link.url, "_blank").focus();
          } else {
            window.setSnackbar(
              "Houve um erro ao criar conta de pagamentos. Entre em contato com o suporte para investigarmos o motivo"
            );
          }
        } catch (e) {
          console.log(e);
        }
        setLoadingCreation(false);
      }

      return (
        <div className="mt-1">
          <span>
            Crie agora sua conta gratuitamente para receber pagamentos através
            da plataforma
          </span>
          <MainButton
            disabled={loadingCreation}
            className="mt-2"
            shadow={false}
            variant="contained"
            color="white"
            onClick={() => handleGoToAccountCreation()}
            endIcon={<SettingsIcon />}
            label={
              <div className="creation-btn">
                {loadingCreation && <Material.CircularProgress size={20} />}
                Criar conta de pagamentos
              </div>
            }
          />
        </div>
      );
    },
    INCOMPLETE_ONBOARDING: () => {
      function handleGoToAccountCreation() {
        handleLoadStatus();
        const url = REF_statusInfo.current.platform_status.links.onboarding.url;
        window.open(url, "_blank").focus();
      }

      return (
        <div className="mt-1">
          <span>
            Complete seu cadastro na plataforma de pagamentos para ativar sua
            conta
          </span>
          <MainButton
            className="mt-2"
            shadow={false}
            variant="contained"
            color="white"
            onClick={() => handleGoToAccountCreation()}
            endIcon={<SettingsIcon />}
            label={<div className="creation-btn">Completar cadastro</div>}
          />
        </div>
      );
    },
    COMPLETE_ONBOARDING: () => (
      <div className="mt-1">
        <small style={{ opacity: 0.6 }}>
          Sua conta foi verificada e já está habilitada a receber pagamentos
        </small>
      </div>
    ),
    LOADING: () => <></>,
    UNKNOWN: () => {
      const [loadingStatus, setLoadingStatus] = useState(false);

      return (
        <div className="mt-1">
          <span>
            Sua conta atualmente está em análise. Este processo pode demorar
            algumas horas
          </span>
          <MainButton
            disabled={loadingStatus}
            className="mt-2"
            shadow={false}
            variant="contained"
            color="white"
            onClick={async () => {
              setLoadingStatus(true);
              await handleLoadStatus();
              setLoadingStatus(false);
            }}
            endIcon={<ReplayIcon />}
            label={"Atualizar status"}
          />
        </div>
      );
    },
  }[status];

  function CurrentBalance() {
    const { available, pending } = REF_statusInfo.current.balance;

    const { bank_name, last4 } =
      REF_statusInfo.current.details?.external_accounts.data[0];

    const { url } = REF_statusInfo.current.login;

    const availableAmount = (available[0].amount / 100).toFixed(2);
    const pendingAmount = (pending[0].amount / 100).toFixed(2);

    function handleGoToDasboard() {
      window.open(url, "_blank").focus();
    }

    return (
      <>
        <div className={"mt-1 current-balance-box " + (compactDisplay && 'current-balance-compact')}>
          <small>Saldo total</small>
          <h2>R${getDisplayPrice(availableAmount + pendingAmount)}</h2>
          <small style={{ opacity: 0.6 }}>
            Saldo disponível: R${getDisplayPrice(availableAmount)}{" "}
          </small>
        </div>
        <div className="wallet-info px-2">
          <span>Conta cadastrada: </span>

          <div className="payout-account-row">
            <Material.Chip
              label={
                <div className="bank-chip">
                  <small>{bank_name}</small>
                  <Material.Divider orientation="vertical" flexItem />
                  <div>
                    <small>Final: {last4}</small>
                  </div>
                  <Material.Tooltip arrow title="Abrir configurações da conta">
                    <Material.IconButton onClick={handleGoToDasboard}>
                      <OpenInNewIcon fontSize="small" />
                    </Material.IconButton>
                  </Material.Tooltip>
                </div>
              }
            />
          </div>

          <small style={{ opacity: 0.6, display: "block" }} className="mt-1">
            Seu saldo será transferido automaticamente para a conta cadastrada
            uma vez ao mês
          </small>
        </div>
      </>
    );
  }

  if (compactDisplay && status === "COMPLETE_ONBOARDING") {
    return (
      <div
        className={"account-status-banner mt-3 pb-2 " + status}
        style={{ ...style }}
      >
        {loading && <Material.LinearProgress />}

        <div className="px-2">
          <div className="account-status-details pt-1">
            {status === "COMPLETE_ONBOARDING" && <CurrentBalance />}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={"account-status-banner mt-3 pb-2 " + status}
      style={{ ...style }}
    >
      {loading && <Material.LinearProgress />}

      <div className=" py-1 px-2  banner-title">
        <AttachMoneyIcon />
        <h4> Conta de pagamentos</h4>
      </div>

      <div className="px-2">
        <div className="account-status-details pt-1">
          <div className="account-status-section">
            <div className="account-status-row mt-1">
              <h5 className="account-status-title-bold">Status da conta:</h5>
              <small className="account-status"> {statusTitle}</small>
            </div>

            <StatusComponent />
          </div>

          {status === "COMPLETE_ONBOARDING" && <CurrentBalance />}
        </div>
      </div>
    </div>
  );
}

function ProductLinksModal() {
  const [modal, setModal] = useState({
    open: false,
    details: [],
  });

  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    if (copiedId) {
      setTimeout(() => {
        setCopiedId(null);
      }, 3000);
    }
  }, [copiedId]);

  window.openPaymentsLinkModal = (prices) => {
    setModal({
      open: true,
      details: prices.filter((p) => p.active),
    });
  };

  function handleCopyUrl(url, productId) {
    navigator.clipboard.writeText(url);
    setCopiedId(productId);
    window.setSnackbar("Link copiado com sucesso");
  }

  function getInterval(interval) {
    return intervalsConfig.filter((i) => i.interval === interval)[0].label;
  }

  return (
    <CustomModal
      maxWidth={580}
      hideSecondaryButton={true}
      title="Links de pagamento"
      handleSubmit={() =>
        setModal({
          open: false,
          details: [],
        })
      }
      bottomButtonSumbitText="Concluir"
      open={modal.open}
      handleClose={() => setModal({ open: false })}
      width="100%"
      bodyWrapperStyle={{}}
      modalClass="get-payment-links-modal"
      bottomButtonsOrientation="vertical"
      bodyComponent={
        <div className="container">
          <h4 className="mb-2">Links disponíveis para este produto:</h4>

          {modal?.details
            ? modal?.details.map((price) => (
                <div
                  className={
                    "price-row mb-1 " +
                    (copiedId === price.id && "copied-price")
                  }
                  key={price.id}
                  onMouseDown={() =>
                    handleCopyUrl(price.checkout_url, price.id)
                  }
                >
                  <span className="price-value">
                    R${getDisplayPrice(price.amount)} /{" "}
                    {getInterval(price.interval)}
                  </span>
                  <Material.Divider orientation="vertical" flexItem />
                  <span className="price-checkout-url">
                    {price.checkout_url}
                  </span>
                  <Material.IconButton
                    color="success"
                    onClick={() => handleCopyUrl(price.checkout_url, price.id)}
                  >
                    {copiedId === price.id ? (
                      <CheckIcon color="success" />
                    ) : (
                      <ContentCopyIcon color="secondary" fontSize="small" />
                    )}
                  </Material.IconButton>
                </div>
              ))
            : null}
        </div>
      }
    />
  );
}

const ProductConfig = ({
  open,
  onClose,
  onCreated,
  details = {},
  mode = "creation",
}) => {
  const { challenges, currentChallenge } = useChallenge();

  const defaultConfig =
    mode === "creation"
      ? {
          name: "",
          description: "",
          default_challenge_id: currentChallenge.challenge_id,
          banner_base64: "",
          type: "recurring",
          prices: [],
          payment_methods: {
            pix: false,
            boleto: true,
            card: true,
          },
        }
      : { ...details };

  const REF_config = useRef(defaultConfig);

  useEffect(() => {
    REF_config.current =
      mode === "creation" ? { ...defaultConfig } : { ...defaultConfig };
  }, [open]);

  const Box = ({ title, children, className = "" }) => {
    return (
      <div className="config-section mb-3 pb-2 ">
        {title && (
          <>
            <div className="px-2 py-1">
              <h4 className="title">{title}</h4>
            </div>
            <Material.Divider />
          </>
        )}

        <div className={"px-2 py-1 " + className}>{children}</div>
      </div>
    );
  };

  const Header = () => (
    <div className="config-modal-header pl-3  pr-2 py-1">
      <h3>Configurar produto</h3>
      <Material.IconButton onClick={onClose}>
        <CloseIcon />
      </Material.IconButton>
    </div>
  );
  const Footer = () => {
    const [loading, setLoading] = useState(false);

    async function handleSubmit() {
      setLoading(true);
      const result = await handleSave();

      if (result) {
        onCreated(result.product_id);
      }

      setLoading(false);
    }

    return (
      <>
        {loading && <Material.LinearProgress color="primary" />}
        <div className="config-modal-footer pl-3  pr-2 py-2">
          <MainButton
            disabled={loading || mode !== "update"}
            shadow={false}
            variant="contained"
            color="error"
            onClick={handleDelete}
            endIcon={<DeleteIcon color="error" />}
            label={"Excluir"}
          />
          <div className="footer-main-btns">
            <MainButton
              disabled={loading}
              shadow={false}
              variant="contained"
              color="white"
              onClick={onClose}
              label={"Cancelar"}
            />
            <MainButton
              disabled={loading}
              shadow={false}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              endIcon={<SendIcon color="primary" />}
              label={"Salvar alterações"}
            />
          </div>
        </div>
      </>
    );
  };

  async function handleSave() {
    try {
      const isInUpdateMode = mode === "update";

      const valid = handleValidate();

      if (!valid) return;

      const conf = REF_config.current;

      let payload = {
        name: conf.name,
        default_challenge_id: conf.default_challenge_id,
        payment_methods: Object.keys(conf.payment_methods).filter(
          (method) => conf.payment_methods[method]
        ),
      };

      if (conf.description) payload.description = conf.description;
      if (conf.banner_base64) payload.banner_base64 = conf.banner_base64;
      if (conf.after_payment_actions) {
        let url = conf.after_payment_actions.redirect_to;

        if (!url.startsWith("http")) url = "https://" + url;

        payload.after_payment_actions = {
          redirect_to: url,
        };
      }

      if (isInUpdateMode) {
        payload.id = conf.id;

        //Preços adicionados
        const addedPrices = conf.prices.filter((price) => !price.id);
        if (addedPrices.length > 0) {
          payload.prices = addedPrices;
        }

        if (conf.removedPrices) {
          payload.prices_to_delete = conf.removedPrices;
        }
      } else {
        payload = {
          ...payload,
          type: conf.type,
          prices: conf.prices.map((v) => {
            v.amount = parseInt(v.amount);
            return v;
          }),
        };
      }

      const { data } = await api[isInUpdateMode ? "patch" : "post"](
        "bank/products",
        { ...payload }
      );

      if (data?.success) {
        window.setSnackbar(
          isInUpdateMode
            ? "Produto atualizado com sucesso"
            : "Produto criado com sucesso"
        );
        return {
          created: true,
          product_id: data.product?.platform_product_id || conf.id,
        };
      }

      window.setSnackbar(
        "Houve um erro inesperado ao criar este produto, confira os valores inseridos, e tente novamente"
      );

      return false;
    } catch (e) {
      console.log(e);
      window.setSnackbar("Houve um erro ao salvar o produto, tente novamente");
    }

    function handleValidate() {
      try {
        //Validações do campo "name"
        if (!REF_config.current.name) throwError("Insira um nome válido");
        if (REF_config.current.name.length < 3)
          throwError("O nome precisa ter mais de 3 caracteres");
        if (REF_config.current.name.length > 50)
          throwError("O nome deve ter menos do que 50 caracteres");

        //Validações do campo "description"
        if (REF_config.current.description.length > 150)
          throwError("A descrição deve ter menos do que 150 caracteres");

        //Validações dos campos "prices[*]"
        const amounts = REF_config.current.prices.map((p) => p.amount);
        if (amounts.length === 0)
          throwError(
            "Você deve adicionar pelo menos um preço para criar um produto"
          );
        if (
          amounts.filter((v) => parseInt(`${v}`?.replace(/\D/g, "")) < 500)
            .length > 0
        )
          throwError("O preço do produto não pode ser menor do que R$5,00");

        //Validações do campo "payment_methods"
        const methods = REF_config.current.payment_methods;
        const checkedMethodsAmount = Object.keys(methods)
          .map((v) => methods[v])
          .filter((v) => v).length;

        if (checkedMethodsAmount === 0)
          throwError("Habilite pelo menos um método de pagamento");

        return true;
      } catch (e) {
        window.setSnackbar(e.message);
      }

      function throwError(msg) {
        throw new Error(msg);
      }
    }
  }
  async function handleDelete() {
    window.openConfirm({
      title: "Remover produto",
      headline: "Atenção!",
      subtitle:
        'Você realmente deseja remover permanentemente o produto "' +
        REF_config.current.name +
        '"?',
      buttons: [
        {
          text: "Apagar permanentemente",
          onClick: handleExecuteDelete,
          variant: "contained",
          className: "",
          color: "error",
        },
        {
          text: "Manter produto",
          variant: "text",
        },
      ],
    });

    async function handleExecuteDelete() {
      try {
        const { data } = await api.delete(
          "/bank/products?id=" + REF_config.current.id
        );

        if (data.success) {
          window.setSnackbar("Produto deletado com sucesso");
          window.loadProducts();
          onClose();
        } else {
          window.setSnackbar(
            "Houve um erro ao apagar este produto, tente novamente em alguns minutos"
          );
        }

        console.log("Deletion result", data);
      } catch (e) {
        window.setSnackbar(
          "Houve um erro ao apagar este produto, tente novamente mais tarde"
        );
      }
    }
  }

  function GeneralConfig() {
    const [image, setImage] = useState(
      REF_config.current.banner_base64 || REF_config.current.banner_url
    );
    const [name, setName] = useState(REF_config.current.name);
    const [description, setDescription] = useState(
      REF_config.current.description
    );

    async function handleAddImage() {
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.onchange = async (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith("image/")) {
          const base64String = await resizeAndConvertImage(file);
          REF_config.current.banner_base64 = base64String;
          setImage(base64String);
        }
      };
      fileInput.click();

      async function resizeAndConvertImage(file) {
        const maxWidth = 480;

        const image = new Image();
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
          reader.onload = (event) => {
            image.src = event.target.result;
          };

          image.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            let width = image.width;
            let height = image.height;

            if (width > maxWidth) {
              height = (height * maxWidth) / width;
              width = maxWidth;
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  resolve(reader.result);
                };
                reader.readAsDataURL(blob);
              },
              "image/jpeg",
              0.8 // Ajuste a qualidade da imagem conforme necessário
            );
          };

          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      }
    }

    return (
      <Box title="Configurações gerais">
        <div className="config-row" style={{ alignItems: "flex-start" }}>
          <button className="add-product-btn" onClick={handleAddImage}>
            {image ? (
              <>
                <img src={image} className="product-image-preview" />
                <EditIcon className="edit-image" color="white" />
              </>
            ) : (
              <>
                <div className="add-photo">
                  <AddAPhotoIcon />{" "}
                </div>
                <small>Foto do produto</small>
              </>
            )}
          </button>

          <Material.TextField
            type="text"
            fullWidth
            placeholder="Nome do produto"
            error={name.length > 50}
            value={name}
            onInput={(v) => {
              REF_config.current.name = v.target.value;
              setName(v.target.value);
            }}
            helperText={
              <FieldCounter
                label="Insira um nome sucinto para o produto"
                counter={`${name.length || 0}/50`}
              />
            }
          />
        </div>

        <Material.TextField
          className="mt-1"
          multiline
          type="text"
          fullWidth
          value={description}
          placeholder="Descrição (opcional)"
          error={description.length > 150}
          onInput={(v) => {
            REF_config.current.description = v.target.value;
            setDescription(v.target.value);
          }}
          helperText={
            <FieldCounter
              label="Adicione mais detalhes sobre o produto"
              counter={`${description.length || 0}/150`}
            />
          }
        />
      </Box>
    );
  }

  function Pricing() {
    const [type, setType] = useState(REF_config.current.type);
    const [prices, setPrices] = useState(REF_config.current.prices);

    function handlePriceInput(event, index) {
      const { value } = event.target;
      const numericValue = value?.replace(/\D/g, "");
      const pricesCopy = [...prices];
      pricesCopy[index].amount = numericValue;
      REF_config.current.prices = [...pricesCopy];
      setPrices([...pricesCopy]);
    }
    function handleChangeInterval(event, i) {
      const pricesCopy = [...prices];
      pricesCopy[i].interval = event.target.value;
      REF_config.current.prices = [...pricesCopy];
      setPrices([...pricesCopy]);
    }
    function getLiquidPrice(value) {
      const platformTax = 4.99;
      if (!value) return "-";
      return getDisplayPrice(
        (
          parseInt(`${value}`.replace(/\D/g, "")) *
          ((100 - platformTax) / 10000)
        ).toFixed(2)
      );
    }
    function handleAddNewPrice() {
      const newPrice = {
        amount: 0,
        interval: "month",
      };

      REF_config.current.prices = [...prices, newPrice];
      setPrices((prev) => [...prev, newPrice]);
    }
    function handleRemovePrice(index) {
      if (mode === "update" && !!prices[index].id) {
        window.openConfirm({
          title: "Remover preço",
          headline: "Atenção",
          subtitle: "Você realmente deseja remover este preço permanentemente?",
          buttons: [
            {
              text: "Confirmar",
              onClick: () => {
                confirmDeletePrice();
                const removedPrices = REF_config.current.removedPrices;
                REF_config.current.removedPrices = removedPrices
                  ? [...removedPrices, prices[index].id]
                  : [prices[index].id];
              },
              variant: "contained",
              color: "error",
            },
            {
              text: "Cancelar",
              variant: "text",
            },
          ],
        });
      } else {
        confirmDeletePrice();
      }

      function confirmDeletePrice() {
        const pricesCopy = [...prices];
        pricesCopy.splice(index, 1);
        REF_config.current.prices = [...pricesCopy];
        setPrices([...pricesCopy]);
      }
    }

    return (
      <Box title="Precificação">
        <Material.Divider className="mt-2">
          <h5 className="subtitle">Tipo de cobrança</h5>
        </Material.Divider>

        <div className="config-row mb-3" style={{ justifyContent: "center" }}>
          <Material.ToggleButtonGroup
            disabled={mode === "update"}
            value={type}
            exclusive
            onChange={(
              event: React.MouseEvent<HTMLElement>,
              newType: string | null
            ) => {
              if (!newType) return;
              console.log(newType, REF_config.current);
              REF_config.current.type = newType;
              setType(newType);
            }}
            className="select-type mt-1"
          >
            <Material.ToggleButton value="recurring" aria-label="list">
              <span>Assinatura</span>
            </Material.ToggleButton>
            <Material.ToggleButton value="one_time" aria-label="module">
              <span>Avulsa</span>
            </Material.ToggleButton>
          </Material.ToggleButtonGroup>
        </div>

        <div
          className="config-row mb-2"
          style={{ justifyContent: "space-between" }}
        >
          <h5 className="mt-2 subtitle">Tabela de preços</h5>
          <Material.Button
            className="create-new-price-btn mt-2"
            variant="contained"
            color="primary"
            onClick={handleAddNewPrice}
            startIcon={<AddIcon />}
          >
            Adicionar preço
          </Material.Button>
        </div>

        <Material.Alert severity="info" className="mb-1">
          Preencha os preços com atenção, pois uma vez criados, eles não poderão
          ser alterados
        </Material.Alert>

        {prices.map((price, index) => {
          const disabledEdition = mode === "update" && !!price.id;
          return (
            <div
              className="config-row mt-1"
              style={{ alignItems: "flex-start" }}
            >
              <Material.TextField
                disabled={disabledEdition}
                type="text"
                size="medium"
                fullWidth
                placeholder="Preço"
                style={{ maxWidth: 175 }}
                value={getDisplayPrice(price.amount)}
                onInput={(e) => handlePriceInput(e, index)}
                InputProps={{
                  startAdornment: (
                    <Material.InputAdornment
                      position="start"
                      className="input-adornment-config"
                    >
                      <span>R$</span>
                      <Material.Divider
                        orientation="vertical"
                        flexItem
                        className="ml-1"
                      />
                    </Material.InputAdornment>
                  ),
                }}
                helperText={
                  <small style={{ marginTop: 3 }}>Valor da cobrança</small>
                }
              />
              <small className="pt-2 px-1">/</small>

              <Material.FormControl className="select-interval">
                <Material.Select
                  disabled={disabledEdition}
                  size="small"
                  id="demo-simple-select"
                  value={price.interval}
                  onChange={(e) => handleChangeInterval(e, index)}
                >
                  {intervalsConfig.map((v, i) => (
                    <Material.MenuItem key={i} value={v.interval}>
                      {v.label}
                    </Material.MenuItem>
                  ))}
                </Material.Select>
                <small style={{ marginTop: 3, marginLeft: 12, opacity: 0.68 }}>
                  Recorrência
                </small>
              </Material.FormControl>

              <Material.IconButton
                onClick={() => handleRemovePrice(index)}
                size="small"
                className="delete-price-btn ml-1 mt-1"
              >
                <DeleteIcon size="small" />
              </Material.IconButton>
            </div>
          );
        })}

        <Material.Divider className="my-2" />
        <h5 className="subtitle">Valores líquidos</h5>
        <Material.TableContainer className="mt-1" component={Material.Paper}>
          <Material.Table aria-label="simple Material.table">
            <Material.TableHead>
              <Material.TableRow
                style={{ backgroundColor: "rgba(0,0,0,0.02)" }}
              >
                <Material.TableCell
                  padding="none"
                  className="py-1 px-2"
                  align="left"
                >
                  Valor bruto
                </Material.TableCell>
                <Material.TableCell
                  padding="none"
                  className="py-1"
                  align="center"
                >
                  Pix
                </Material.TableCell>
                <Material.TableCell
                  padding="none"
                  className="py-1"
                  align="center"
                >
                  Crédito
                </Material.TableCell>
                <Material.TableCell
                  padding="none"
                  className="py-1"
                  align="center"
                >
                  Boleto
                </Material.TableCell>
              </Material.TableRow>
            </Material.TableHead>
            <Material.TableBody>
              {prices.map((row) => {
                const { boleto, pix, card_national, card_international } =
                  getLiquidValue(row.amount);

                return (
                  <Material.TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <Material.TableCell component="th" scope="row">
                      R${getDisplayPrice(row.amount)} /{" "}
                      <small>
                        {
                          intervalsConfig.filter(
                            (i) => row.interval === i.interval
                          )[0].label
                        }
                      </small>
                    </Material.TableCell>
                    <Material.TableCell align="center">
                      {row.amount === 0 ? (
                        "-"
                      ) : (
                        <small>
                          R${getDisplayPrice((pix / 100).toFixed(2))}
                        </small>
                      )}
                    </Material.TableCell>
                    <Material.TableCell align="center">
                      {row.amount === 0 ? (
                        "-"
                      ) : (
                        <small>
                          R${getDisplayPrice((card_national / 100).toFixed(2))}
                        </small>
                      )}
                    </Material.TableCell>
                    <Material.TableCell align="center">
                      {row.amount === 0 ? (
                        "-"
                      ) : (
                        <small>
                          R${getDisplayPrice((boleto / 100).toFixed(2))}
                        </small>
                      )}
                    </Material.TableCell>
                  </Material.TableRow>
                );
              })}
            </Material.TableBody>
          </Material.Table>
        </Material.TableContainer>
      </Box>
    );
  }

  function PaymentMethods() {
    const [methods, setMethods] = useState(REF_config.current.payment_methods);

    const methodsAvailable = [
      {
        disabled: true,
        key: "pix",
        label: "Pix (em breve)",
        icon: <PixIcon color={methods.pix ? "primary" : "black"} />,
      },
      {
        key: "card",
        label: "Cartão de crédito",
        icon: <PaymentIcon color={methods.card ? "primary" : "black"} />,
      },
      {
        key: "boleto",
        label: "Boleto",
        icon: <BoletoIcon color={methods.boleto ? "#6b2dee" : "black"} />,
      },
    ];

    function handleMethodToggle(key) {
      const methodsCopy = { ...methods };
      methodsCopy[key] = !methods[key];
      REF_config.current.payment_methods = { ...methodsCopy };
      setMethods({ ...methodsCopy });
    }

    return (
      <Box title="Métodos de pagamento">
        {methodsAvailable.map((method, i) => (
          <div
            className={
              "payment-method " +
              (method.disabled && "disabled-method ") +
              (methods[method.key] && " active")
            }
            onClick={(e) => {
              if (!method.disabled) {
                handleMethodToggle(method.key);
              }
            }}
          >
            {method.icon}
            <Material.Divider orientation="vertical" flexItem />
            <Material.Switch
              checked={methods[method.key]}
              onChange={(e) => handleMethodToggle(method.key)}
            />
            <span>{method.label}</span>
          </div>
        ))}
      </Box>
    );
  }

  function RedirectRule() {
    const [redirectTo, setRedirectTo] = useState(
      REF_config.current.after_payment_actions?.redirect_to?.replace(
        "https://",
        ""
      ) || ""
    );

    return (
      <Box title="Redirecionamento">
        <div className="pt-1"></div>
        <span>
          Configure a url para onde o cliente será redirecionado quando o
          pagamento for concluído (opcional)
        </span>

        <Material.TextField
          type="text"
          fullWidth
          placeholder="seusite.com.br"
          className="mt-1"
          helperText="Url de direcionamento (opcional)"
          value={redirectTo}
          InputProps={{
            startAdornment: (
              <Material.InputAdornment
                position="start"
                className="input-adornment-config"
              >
                <span>https://</span>
                <Material.Divider
                  orientation="vertical"
                  flexItem
                  className="ml-1"
                />
              </Material.InputAdornment>
            ),
          }}
          onInput={(v) => {
            const { value } = v.target;

            if (!!value) {
              REF_config.current.after_payment_actions = {
                redirect_to: v.target.value,
              };
            } else {
              REF_config.current.after_payment_actions = undefined;
            }

            setRedirectTo(value);
          }}
        />
      </Box>
    );
  }
  function DefaultChallenge() {
    const [selected, setSelected] = useState(
      defaultConfig.default_challenge_id
    );

    function handleChoseChallenge(event) {
      const { value } = event.target;

      REF_config.current.default_challenge_id = value;

      setSelected(value);
    }

    return (
      <Box>
        <div
          style={{ display: "flex", alignItems: "center", gap: "20px" }}
          className="mb-1"
        >
          <h4 style={{ textWrap: "nowrap" }}>Desafio padrão: </h4>
          <Material.FormControl fullWidth>
            <Material.Select
              fullWidth
              size="small"
              id="demo-simple-select"
              value={selected}
              onChange={(e) => handleChoseChallenge(e)}
            >
              {challenges.map((v, i) => (
                <Material.MenuItem key={i} value={v.challenge_id}>
                  <div className="select-challenge-default">
                    {v.banner ? (
                      <img src={v.banner} className="challenge-banner-select" />
                    ) : (
                      <div className="challenge-banner-select"></div>
                    )}
                    <h5>{v.name}</h5>
                  </div>
                </Material.MenuItem>
              ))}
            </Material.Select>
          </Material.FormControl>
        </div>
        <Material.Alert severity="info">
          Quando o pagamento for concluído, o usuário será automaticamente
          incluído no desafio acima
        </Material.Alert>
      </Box>
    );
  }

  return (
    <Material.Drawer
      className="configure-product-modal"
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Header />

      <div className="configs-body px-3 pb-2 pt-5">
        <GeneralConfig />

        <Pricing />

        <PaymentMethods />

        <RedirectRule />

        <DefaultChallenge />
      </div>

      <Footer />
    </Material.Drawer>
  );
};

function getLiquidValue(totalAmount) {
  const tax_pix = 0.0119;
  const tax_boleto = 0;
  const tax_national_credit = 0.0399;
  const tax_international_credit = 0.0599;

  const tax_credit_fixed = 39;
  const tax_boleto_fixed = 345;

  const tax_platform = 0.02; // 2%

  return {
    pix: calculate(tax_pix),
    boleto: calculate(tax_boleto, tax_boleto_fixed),
    card_national: calculate(tax_national_credit, tax_credit_fixed),
    card_international: calculate(tax_international_credit, tax_credit_fixed),
  };

  function calculate(taxaStripe, tax_credit_fixed = 0) {
    const valorLiquidoStripe =
      totalAmount - totalAmount * taxaStripe - tax_credit_fixed;
    const valorLiquidoFinal = valorLiquidoStripe * (1 - tax_platform);
    return valorLiquidoFinal;
  }
}

function getDisplayPrice(value) {
  if (!value) return value;
  const numericValue = `${value}`?.replace(/\D/g, "");
  const integerPart = numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
  const decimalPart = numericValue.slice(-2);

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${formattedInteger},${decimalPart}`;
}

export { AccountStatus };

const intervalsConfig = [
  {
    interval: "week",
    label: "Semanal",
  },
  {
    interval: "month",
    label: "Mensal",
  },
  {
    interval: "bimonthly",
    label: "Bimestral",
  },
  {
    interval: "quarterly",
    label: "Trimestral",
  },
  {
    interval: "semiannual",
    label: "Semestral",
  },
  {
    interval: "year",
    label: "Anual",
  },
];

const FieldCounter = ({ label, counter }) => (
  <div className="field-counter">
    <small>{label}</small>
    <small>{counter}</small>
  </div>
);
